export const CatchesIcon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2070_20930)">
      <rect width="36" height="36" rx="18" fill="currentcolor" />
      <g filter="url(#filter0_d_2070_20930)">
        <path
          d="M10.5833 19.7473C10.0945 20.0149 5.705 22.389 5.04073 21.6363C4.66072 21.2015 7.10535 18.6921 7.10535 17.8998C7.10535 17.1084 4.66172 14.5952 5.03973 14.1662C5.82568 13.2743 10.1305 15.7846 10.5873 16.0542C14.6312 14.1662 17.5809 13 22.0572 13C27.895 13 31 16.5 31 17.9037C31 19.3073 26.5904 23 22.0572 23C17.5769 23 13.9759 21.1019 10.5833 19.7473Z"
          fill="#6D859C"
        />
        <path
          d="M10.5833 19.7473C10.0945 20.0149 5.705 22.389 5.04073 21.6363C4.66072 21.2015 7.10535 18.6921 7.10535 17.8998C7.10535 17.1084 4.66172 14.5952 5.03973 14.1662C5.82568 13.2743 10.1305 15.7846 10.5873 16.0542C14.6312 14.1662 17.5809 13 22.0572 13C27.895 13 31 16.5 31 17.9037C31 19.3073 26.5904 23 22.0572 23C17.5769 23 13.9759 21.1019 10.5833 19.7473Z"
          stroke="#F8F9FA"
          strokeWidth="1.7"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_2070_20930"
        x="1.15027"
        y="10.1504"
        width="33.6997"
        height="17.6992"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2070_20930" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2070_20930"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_2070_20930">
        <rect width="36" height="36" rx="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
